import VideoCameraFront from '@mui/icons-material/VideoCameraFront';
import { Tooltip, Typography } from '@mui/material';
import { observable, makeObservable, runInAction, action } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconeAdvogadoSustentacaoOralTelepresencial extends Component {
    titlePadrao = (<Typography>Pedido de preferência/sustentação, por videoconferência</Typography>);
    corPadrao = 'black';
    opacidadePadrao = '1';

    title = null;
    color = null;
    removerTooltip = false;
    idPadrao = 'idIconeAdvogadoTelepresencial';

    static get sxPadrao() {
        return {
            color: this.corPadrao,
            fill: this.corPadrao,
            fillOpacity: this.opacidadePadrao
        };
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            title: observable,
            color: observable,
            removerTooltip: observable,
            idPadrao: observable,
            atualizarPropsIcone: action,
            adicionarSxPadrao: action
        });

        runInAction(() => {
            this.idPadrao = this.props.id ? this.props.id : this.idPadrao;
        });
    }

    atualizarPropsIcone(propsIcone) {
        this.propsIcone = propsIcone;
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            runInAction(() => {
                this.propsIcone.sx = IconeAdvogadoSustentacaoOralTelepresencial.sxPadrao;
            });
        } else {
            runInAction(() => {
                this.propsIcone.sx = { ...IconeAdvogadoSustentacaoOralTelepresencial.sxPadrao, ...this.propsIcone.sx };
            });
        }
    }

    render() {
        if (this.removerTooltip) {
            return <VideoCameraFront sx={this.props.sx ? this.props.sx : this.props.style} />;
        } else {
            return (
                <Tooltip title={this.titlePadrao}>
                    <VideoCameraFront
                        id={this.idPadrao}
                        sx={this.props.sx ? this.props.sx : this.props.style}
                    />
                </Tooltip>
            );
        }
    }
}

IconeAdvogadoSustentacaoOralTelepresencial.corPadrao = 'black';

IconeAdvogadoSustentacaoOralTelepresencial.opacidadePadrao = '1';

IconeAdvogadoSustentacaoOralTelepresencial.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node,
    sx: PropTypes.object,
    style: PropTypes.object,
    id: PropTypes.string
};

export default observer(IconeAdvogadoSustentacaoOralTelepresencial);
